import { BreakpointsTable } from "../../../../../../packages/design-system/grid/constellation/usage/breakpoints-table";
import * as React from 'react';
export default {
  BreakpointsTable,
  React
};